// Address comparison shared by the server and the web app.
/**
 * Does Google's address describe the same spot as Pilot's? Compares the street number and ZIP,
 * which catches Google matching a same-named office across town. True when there's nothing to compare.
 */
export function sameAddress(pilot, google) {
  const num = (a) => (String(a || '').trim().match(/^(\d+)/) || [])[1];
  const zip = (a) => (String(a || '').match(/\b(\d{5})(?:-\d{4})?\b(?!.*\b\d{5}\b)/) || [])[1];
  const [n1, n2, z1, z2] = [num(pilot), num(google), zip(pilot), zip(google)];
  if (n1 && n2 && n1 !== n2) return false;
  if (z1 && z2 && z1 !== z2) return false;
  return true;
}
